import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface AccordianBodyProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ref?: ForwardedRef<HTMLDivElement>;
}

const AccordianBody = forwardRef((props: AccordianBodyProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { children, className, ...rest } = props;

    return (
        <div {...rest} ref={ref} className={twMerge('pt-2', className)}>
            {children}
        </div>
    );
});

export default AccordianBody;
